import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  padding: ${theme.spacing['6xl']} 0;
`;
